import { PipeTransform } from '@angular/core';
import * as moment from 'moment';
var HumanizeDurationPipe = /** @class */ (function () {
    function HumanizeDurationPipe() {
    }
    /**
     * @param to in format 'DD-MM-YYYY'
     * @param from in format 'DD-MM-YYYY'
     * @returns humanized duration as example: "1 month"
     */
    HumanizeDurationPipe.prototype.transform = function (to, from) {
        return moment.duration(moment(to).diff(from)).humanize();
    };
    return HumanizeDurationPipe;
}());
export { HumanizeDurationPipe };
